import api, { API_BASE, defaultOpt } from "./apiService";

export async function getAllInbound() {
  return (await api.get(`${API_BASE}/list-inbound`)).data;
}

export async function addInbound(formAdd) {
  return (await api.post(`${API_BASE}/add-inbound`, formAdd, defaultOpt()))
    .data;
}

export async function deleteInbound(id) {
  return (await api.delete(`${API_BASE}/delete-inbound/${id}`, defaultOpt()))
    .data;
}

export async function updateInbound(id, form) {
  return (await api.put(`${API_BASE}/edit-inbound/${id}`, form, defaultOpt()))
    .data;
}

export const sourceOptions = [
  { value: "KITWS", label: "KIT machine workshop" },
  { value: "IIT", label: "IIT Madras" },
  { value: "CIEMAT", label: "CIEMAT" },
  { value: "KITPUR", label: "KIT private purchase" },
  { value: "CERN", label: "CERN purchase" },
  { value: "Other", label: "Other" },
];

export const inboundTypeOptions = [
  { value: "BAREPLATE", label: "Cut bare baseplates" },
  { value: "KAPTON", label: "Kapton sheets" },
  { value: "TAPE", label: "Tape" },
];

export const inboundGeometryOptions = [
  "F0W",
  "F0T",
  "FLW",
  "FHW",
  "FLT",
  "FHT",
  "FL0",
  "FH0",
  "BLW",
  "BLT",
  "TLW",
  "TLT",
  "BL0",
  "TL0",
  "5LW",
  "5LT",
  "5L0",
  "LLW",
  "RLW",
  "SLW",
  "LLT",
  "RLT",
  "LL0",
  "RL0",
  "LHW",
  "RHW",
  "SHW",
  "BHW",
  "THT",
].map((x) => {
  return { value: x, label: x };
});
